/**
 * Counting things in sentences.
 */

/**
 * '1 work out on placement' / '4 works out on placement'.
 *
 * A function rather than a template in the copy file, because "1 works" is the
 * kind of thing that ships and then stays. The pair comes from the screen's
 * constants so the noun stays copy and only the arithmetic lives here.
 */
export function plural(count: number, [one, many]: readonly [string, string]): string {
  return count === 1 ? `1 ${one}` : `${count} ${many}`;
}
